import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Atras = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navegar hacia atrás
  };

  return (
    <IconButton
      onClick={handleGoBack}
      aria-label="Volver"
      sx={{
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        color: 'text.primary',
        '&:hover': { bgcolor: 'background.paper', borderColor: 'text.secondary' },
      }}
    >
      <ArrowBackIcon fontSize="small" />
    </IconButton>
  );
};

export default Atras;
